<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">抬头类型：</span>
        </div>
        <el-radio-group v-model="formData.type" size="small">
          <el-radio label="COMPANY">企业</el-radio>
          <el-radio label="PERSON">个人</el-radio>
        </el-radio-group>
      </div>

      <div class="form-line" v-if="formData.type === 'COMPANY'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">开票抬头：</span>
        </div>
        <el-select v-model="formData.name" filterable remote reserve-keyword placeholder="请输入关键词" size="small" style="width: 280px" :remote-method="getTycEnterprise">
          <el-option v-for="item in enterpriseList" :key="item.name" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="formData.type === 'PERSON'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">开票抬头：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>

      <div v-if="formData.type === 'COMPANY'">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">纳税人识别号：</span>
          </div>
          <el-input v-model="formData.taxPayerIdentificationNumber" size="small" style="width: 280px" />
        </div>

        <div class="form-line">
          <div class="textBox">
            <span class="line-text">地址：</span>
          </div>
          <el-input v-model="formData.address" size="small" style="width: 280px" />
        </div>

        <div class="form-line">
          <div class="textBox">
            <span class="line-text">开户银行：</span>
          </div>
          <el-input v-model="formData.bank" size="small" style="width: 280px" />
        </div>

        <div class="form-line">
          <div class="textBox">
            <span class="line-text">开户账号：</span>
          </div>
          <el-input v-model="formData.bankAccount" size="small" style="width: 280px" />
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">联系方式：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">邮箱：</span>
        </div>
        <el-input v-model="formData.email" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm value="保存" @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/invoice'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import {pattern} from "../../../utils/regular";

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'invoice-rise-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧凭证',
          name: 'invoice-over-view'
        }, {
          value: '抬头管理'
        }],
        mainTitle: '修改抬头',
        subheading: '',

        enterpriseList: [],
        formData: {
          type: '',
          name: '',
          taxPayerIdentificationNumber: '',
          address: '',
          phone: '',
          bank: '',
          bankAccount: '',
          email: ''
        },
      }
    },
    created () {
      this.getInvoiceTitleByCode()
    },
    methods: {
      // 查询住户信息
      getTycEnterprise (query) {
        this.formData.name = query
        if (query.length > 3) {
          this.$axios.get(`${api.getTycEnterprise}/${query}`, {})
            .then(res => {
              this.enterpriseList = res.data.data.items || []
              this.enterpriseList.map(v => {
                if (v.name === this.formData.name) {
                  this.formData.taxPayerIdentificationNumber = v.creditCode
                }
              })
            })
            .catch(errorHandler('查询失败'))
        }
      },

      toManagementPage () {
        this.$router.push({
          name: 'invoice-rise-manage'
        })
      },

      // 查询
      getInvoiceTitleByCode () {
        this.$axios.get(`${api.getInvoiceTitleByCode}/${this.$route.params.id}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.formData = res.data.data
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 保存
      confirm () {
        if (!this.formData.type) {
          nError('请选择抬头类型')
          return false
        }
        if (!this.formData.name) {
          nError('请输入开票抬头')
          return false
        }
        if (this.formData.type === 'COMPANY' && !this.formData.taxPayerIdentificationNumber) {
          nError('请输入纳税人识别号')
          return false
        }
        if (this.formData.type === 'PERSON') {
          this.formData.taxPayerIdentificationNumber = ''
          this.formData.address = ''
          this.formData.bank = ''
          this.formData.bankAccount = ''
        }
        this.$axios.post(api.updateInvoiceTitle, this.formData)
          .then(res => {
            nSuccess('修改成功')
            this.toManagementPage()
          })
          .catch(errorHandler('修改失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    },
    watch: {
      'formData.name': {
        handler(newName, oldName) {
          this.enterpriseList.map(v => {
            if (v.name === this.formData.name) {
              this.formData.taxPayerIdentificationNumber = v.creditCode
            }
          })
        },
        deep: true
      },
    }
  }
</script>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/Invoice/InvoiceRise/InvoiceRiseModify.vue